const Mark = ({ bg, fg }) => (
  <>
    <rect width="64" height="64" rx="14" fill={bg} />
    <path d="M21 14v36M21 37l16-16M29 30l15 20" stroke={fg} strokeWidth="4.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="44" cy="15.5" r="5.5" fill="#C85A32" />
  </>
);

export const LogoMark = ({ className = "h-9 w-9", light = false }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <Mark bg={light ? "#FBF9F5" : "#1C1917"} fg={light ? "#1C1917" : "#FBF9F5"} />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark light={light} />
    <span className={`flex flex-col leading-none ${light ? "text-[var(--bone)]" : "text-[var(--ink)]"}`}>
      <span className="font-display text-[1.35rem] font-medium tracking-[0.14em]">KAIROS</span>
      <span className="font-mono-label mt-1 hidden text-[9px] text-[var(--muted)] sm:block">Maison · Bureau · Esprit</span>
    </span>
  </span>
);
